<template>
    <div class="textArea" id="textArea" :style="'height:'+getlistheight+'px;'">
        <div id='dropline' @mousedown.stop.prevent="mouseDownTop" class="dropline"></div>
        <div class="expression">
            <!-- 表情按钮 -->
            <a href="javascript:;" title="表情" class="icon_bq" :class="{'icon_bq_on':showexpression}" @click.stop="oppenexpression"></a>
            <!-- 语音按钮 -->
            <a href="javascript:;" title="语音" class="icon_microphone" :class='{icon_microphone_on:showRecorder}' @click.stop="oppenRecorder"></a>
            <!-- 上传按钮 -->
            <a href="javascript:;" title="文件" class="icon_folder_add" :class='{icon_folder_add_on:showFile}'>
                <input type="file" @change="sendfile">
            </a>
            <a href="javascript:;" class="icon_syschat" :class="{icon_syschat_on:chartVisible}" @click.stop="oppenchart" title="同步聊天记录"></a>

            <div class="expressionlist" v-show="showexpression">
                <!-- 表情 -->
                <el-scrollbar style="height: 100%;">
                    <ul>
                        <li v-for="(item,index) in 282" :key='index' @click="addexpression(index)">
                            <a href="javascript:;" :class="'intro-'+index" v-if="index<=104"></a>
                            <!-- <img :src="item.src" alt=""> -->
                            <a href="javascript:;" :class="'intromoji-'+index" v-else></a>
                        </li>
                    </ul>
                </el-scrollbar>

            </div>
        </div>

        <textareaModel :talkvaltime="talkvaltime" :talkval="talkval" @input="changeinput" @listen="sendmsg" @closeexpression="closeexpression" ref="texareaModel"></textareaModel>

        <a href="javascript:;" class="btn_send" @click='sendmsg'>发送</a>

        <!-- 录音弹窗 -->
        <recorder :dialogVisible="showRecorder" v-if="showRecorder" @closeRecorder="closeRecorder"></recorder>
        <!-- 同步聊天弹窗 -->
        <syncChart :chartVisible='chartVisible' v-if="chartVisible" @closechart='closechart' @closechart0='closechart0'></syncChart>
        <!-- 话术弹窗 -->
        <seltalk :talkdialog='showtalkdialog' :tdata="tdata" @closetalk='closetalk'></seltalk>
        <!-- 拖拽文件弹窗 -->
        <selfile :filedialog='showfiledialog' @changeload="changeload" :sdata="sdata" @closefile='closefile'></selfile>

        <!-- 新loading -->
        <div class="newloading" v-show="showloading">
            <div class="mask"></div>
            <div class="con">
                <p>{{loadtxt}}</p>
                <div class="loadingimg">
                    <img src="/static/img/icon_loading.png" alt="">
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import {
        mapGetters,
        mapMutations 
    } from 'vuex'
    import {
        messageSensitiveCheck,
        chatcheckSensitiveWord
    } from '@/utils/api-im.js'
    // 获取表情json数据
    import uploadfile from '@/utils/upload.js'
    import facedata from '@/utils/face.json';
    import seltalk from './seltalk'
    import selfile from './selfile'
    import recorder from './recorder'
    import syncChart from './syncChart'
    import textareaModel from './textareaModel'
    export default {
        name:'inputBox',
        data(){
            return{
                showexpression: false, //是否显示表情包
                showRecorder: false,//录音
                showFile: false,//文件
                chartVisible:false, //聊天记录弹窗
                cansync: false,//同步聊天记录权限
                facedata: facedata, //表情数据
                chatValue: '', //输入的聊天内容
                talkval:'',//话术内容
                talkvaltime: 0,//话术时间戳
                startPos: 0, //光标位置
                endPos: 0, //光标位置
                sendTxt: '', //替换完表情的聊天内容
                showtalkdialog:false,//选择话术弹窗
                tdata:{},//话术内容
                showfiledialog: false,//拖拽文件弹窗
                sdata:{},//拖拽文件内容
                toolsContent: {
                    contentType: 1,
                }, //发送的消息体
                getlistheight: '',
                showloading:false,
                loadtxt:'正在进行敏感词检测...'
            }
        },
        components: {
            recorder,
            syncChart,
            textareaModel,
            seltalk,
            selfile
        },
        props:{
        },
        computed: {
            ...mapGetters('im', [
                'selectfriendids',
                'cansend'
            ])
        },
        mounted() {
            this.$nextTick(() => {
                // 重置输入框高度
                window.onresize = () => {
                    this.resetchatheight()
                }

                // 获取im发起聊天权限
                this.wxim = sessionStorage.getItem('wx_im')
                this.resetchatheight()
            })
            let authPrivileges = localStorage.getItem('authPrivileges')
            if(authPrivileges) {
                authPrivileges = JSON.parse(authPrivileges)
                for (let i = 0; i < authPrivileges.length; i++) {
                    if (authPrivileges[i].bt == "IM") {
                        //查看是否有聊天权限
                        //查看是否有聊天权限
                            const arr = authPrivileges[i].list.filter(v => { return v.pc == 'wx_im_chat_list_page' })
                            let imdata = [];
                            if (arr && arr.length > 0) {
                            imdata = arr[0].list;
                            }else{
                            imdata = authPrivileges[i].list
                            }
                        for (let j = 0; j < imdata.length; j++) {
                            if (imdata[j].pc == "wx_im_sync_chat_message") {
                                this.cansync = true
                            }
                        }
                    }
                }
            }
            // 拖拽事件
            let dropbox = document.querySelector('#textArea');
            dropbox.addEventListener('dragenter', this.onDrag, false);
            dropbox.addEventListener('dragover', this.onDrag, false);
            dropbox.addEventListener('drop', this.onDrop, false);
            // 监听话术
            window.addEventListener('message', event=> {
                // 监听crmiframe传参
                let data = event.data
                if (data.type == 'showtalkdialog') {
                    if(data.seltype != 1){
                        if(data.seltype ==2){
                            this.talkvaltime = (new Date()).getTime()
                            this.talkval = '<img style="max-width: 120px;max-height: 214px;" src="'+ data.con.con +'" alt="">'
                        }else{
                            this.showtalkdialog = true
                            this.tdata = {
                                type:data.seltype,
                                data:data.con
                            }
                        }
                    }else{
                        this.talkvaltime = (new Date()).getTime()
                        this.talkval = data.con.con
                    }
                }
            }, false);
        },
        methods:{
            ...mapMutations('im', [
                'MSGID'
            ]),
            changeload(bool){
                if(bool){
                    this.showloading=true
                    this.loadtxt='正在上传文件...'
                }else{
                    this.showloading=false
                }
            },
            // 关闭话术选择
            closetalk() {
                this.showtalkdialog = false
                this.tdata = {}
            },
            closefile(){
                this.showfiledialog = false
                this.sdata = {}
            },
            onDrag(e) {
                e.stopPropagation();
                e.preventDefault();
            },
            onDrop(e) {
                e.stopPropagation();
                e.preventDefault();
                let dt = e.dataTransfer;
                // document.querySelector('.imgName').innerHTML = imgfile.files[0].name;
                if(dt.files.length > 1){
                    this.$toast('仅支持单个文件')
                    return false
                }
                console.log(dt.files)
                let filedata = {
                    fname:dt.files[0].name,
                    fsize:dt.files[0].size
                }
                this.uploadCheck(dt.files[0]).then(data => {
                    let reader = new FileReader();
                    reader.readAsDataURL(dt.files[0]);
                    reader.onload = e=> {
                        console.log(data,'data')
                        if(data.type == "2"){
                            this.$refs.texareaModel.$refs.textarea.focus()
                            let str = `<img data-name="${data.file.name}" data-type="${data.file.type}" style="max-width: 120px;max-height: 214px;" src="${e.target.result}">`
                            this.$refs.texareaModel.insertHtmlAtCaret(str)
                        }else{
                            filedata.con = e.target.result
                            filedata.st = data.suffix.replace('.','')
                            this.showfiledialog = true
                            data.data = filedata
                            this.sdata = data
                        }
                    };
                    
                })
            },
            changeinput(val){
                this.chatValue = val
            },
            closechart(){
                this.chartVisible=false
            },
            closechart0(data){
                this.chartVisible=false
                const msgContent = {
                    weChatId:this.selectfriendids.wechatContactinfo.wechatid,
                    friendId:this.selectfriendids.wechatContactinfo.friendid,
                    start:data[0]+' 00:00:00',
                    end:data[1]+' 23:59:59',
                    flag:1
                }
                this.$toast('同步中，稍后刷新页面查看同步结果');
                console.log(msgContent, 'msgContent')
                this.socketApi.sendSock({
                    msgType: "SYNC_WECHAT_MESSAGE_REQ",
                    msgContent:  msgContent
                })
            },
            //显示表情包
            oppenexpression() {
                this.showRecorder = false
                this.showexpression = !this.showexpression
                this.$refs.texareaModel.$refs.textarea.focus()
                console.log('oppenexpression')
                console.log(this.$refs.texareaModel.$refs.textarea,'oppenexpression')

            },
            // 输入表情
            addexpression(index) {
                let face = this.selectExpression(index)
                const value = this.chatValue
                let el = this.$refs.texareaModel;
                console.log(el,'this.$refs.')
                this.$refs.texareaModel.insertHtmlAtCaret(face)
                this.toolsContent.contentType = 1
            },

            // 选择表情
            selectExpression(val) {
                this.showexpression = false
                let rm = this.facedata.expressionMap[val]
                let qqList = [113, 114, 115, 116, 117, 118, 124, 125]
                // qq表情
                if (rm) {
                    if (val < 105 || qqList.indexOf(val) >= 0) {
                        rm = '[' + this.facedata.expressionMap[val] + ']'
                    } else {
                        rm = '<' + rm + '>'
                        rm = this.facedata.emojiMap[rm]
                        // let en = '😁'
                        // let encode = en.codePointAt(0)
                        let rmencode = parseInt(rm, 16)
                        rm = String.fromCodePoint(rmencode)
                    }
                    return rm
                } else {
                    console.log('无效选择')
                    return ''
                }
            },
        
            //发送聊天内容
            sendmsg() {
                console.log('666')
                let txtcon = this.chatValue
                txtcon = this.chatValue.replace(/<(?!img).*?>/g, "")
                let fdata = this.selectfriendids;
                let arr = []

                if (this.chatValue == '') {
                    return false;
                }
                const chatvalarr = this.stringToArray(txtcon)
                console.log(chatvalarr,'chatvalarr')
                const reg = /(<img[^>]*>)/ig//匹配img
                if(chatvalarr.length ==1 && !reg.test(chatvalarr[0])){
                    // 纯文本发送方式
                    txtcon = txtcon.replace(/&nbsp;/g, '')
                    let uuid = uploadfile.generateUUID()
                    this.showloading=true
                    this.loadtxt='正在进行敏感词检测...'
                    this.$post(messageSensitiveCheck, {
                        wechatid: this.selectfriendids.wechatContactinfo.wechatid,
                        friendid: this.selectfriendids.wechatContactinfo.friendid,
                        contentType: this.toolsContent.contentType,
                        content: txtcon,
                        sendUuid: uuid
                    }).then((res) => {
                        this.showloading=false
                        if (res.data.code == 200) {
                            let sendStatus = 1
                            // txtcon = base64.b64EncodeUnicode(txtcon)
                            console.log(txtcon,'发送前打印的',uuid)
                            if (res.data.data.handleType == 0) {
                                this.$confirm('此信息包含敏感词【'+res.data.data.sensitiveName+'】，请谨慎发送', '提示', {
                                    confirmButtonText: '发送',
                                    cancelButtonText: '取消',
                                    type: 'warning'
                                }).then(() => {
                                    this.MSGID(uuid) //保存uuid
                                    this.socketApi.sendSock({
                                        msgType: "TALK_TO_FRIEND_REQ",
                                        msgContent: {
                                            weChatId: this.selectfriendids.wechatContactinfo.wechatid,
                                            friendId: this.selectfriendids.wechatContactinfo.friendid,
                                            contentType: this.toolsContent.contentType,
                                            content: txtcon,
                                            sendUuid: uuid,
                                            sendStatus:sendStatus
                                        }
                                    })
                                    this.chatValue = '' //发送内容后清空输入内容
                                    this.$refs.texareaModel.clearval()//清空输入框
                                    this.showexpression = false
                                })
                                return false
                            }
                            let sensitiveName = ''
                            if (res.data.data.handleType == 1) {
                                sendStatus = 3
                            }
                            this.MSGID(uuid) //保存uuid
                            this.socketApi.sendSock({
                                msgType: "TALK_TO_FRIEND_REQ",
                                msgContent: {
                                    weChatId: this.selectfriendids.wechatContactinfo.wechatid,
                                    friendId: this.selectfriendids.wechatContactinfo.friendid,
                                    contentType: this.toolsContent.contentType,
                                    content: txtcon,
                                    sendUuid: uuid,
                                    sendStatus:sendStatus,
                                }
                            })
                            this.chatValue = '' //发送内容后清空输入内容
                            this.$refs.texareaModel.clearval()//清空输入框
                            this.showexpression = false
                        }else{
                            this.$toast('敏感词检测失败！');
                        }
                    })
                }else{
                    // 图文混排发送方式
                    let txtarr = []
                    let txtcheck;
                    // 重组并取出文字和图片数组
                    console.log(chatvalarr,'chatvalarr')
                    const objdata = this.resetchatarr(chatvalarr)
                    console.log(objdata,'objdata')
                    // return false
                    if(objdata.txtarr.length>0){
                        txtcheck = ()=>{
                            return new Promise((resolve,reject)=>{
                                this.showloading=true
                                this.loadtxt='正在进行敏感词检测...'
                                // 校验敏感词
                                this.$post(chatcheckSensitiveWord,{
                                    contentList:objdata.txtarr
                                }).then(res => {
                                    if(res.data.code == 200){
                                        if(res.data.data.length>0){
                                            this.showloading=false
                                            reject()
                                            let arr = []
                                            for(let i = 0;i<res.data.data.length;i++){
                                                arr.push(res.data.data[i].sensitiveWordsList[0].sensitiveName)
                                            }
                                            let str = arr.join(',')
                                            this.$confirm('发送内容包含敏感词['+str+'],请修改后发送', '提示', {
                                                confirmButtonText: '确定',
                                                type: ''
                                            }).then(() => {
                                            })
                                        }else{
                                            resolve()
                                        }
                                    }else{
                                        this.$toast(res.data.msg)
                                        reject(res.data.msg)
                                    }
                                }).catch(err => {
                                    this.$toast(err)
                                    reject(err)
                                })
                                // resolve('文字校验')
                                setTimeout(res=>{
                                    console.log('敏感词检测完成')
                                    resolve('文字校验')
                                },2000)
                            })
                        }
                    }
                    console.log('111')
                    if(txtcheck){
                        txtcheck().then(res=>{
                             // 执行
                            console.log('图片上传中1111')
                            this.upimgs(objdata)
                            
                        })
                    }else{
                        console.log('图片上传中222')
                        this.upimgs(objdata)
                    }
                }
                console.log('txtcon',chatvalarr)
            },
            // 混排图片上传
            upimgs(objdata){
                let queue= []
                const arr = [...objdata.newarr]
                console.log(arr,'arr')
                arr.forEach((v) => {

                    // 图片
                    if(v.type == 'img' && v.file){
                        let upfun = ()=>{
                            console.log('图片方法')
                            return new Promise((resolve,reject)=>{
                                    // resolve('图片上传')
                                    console.log('执行图片上传逻辑')
                                    //获取oss
                                    uploadfile.getossbase(v.file,true).then(osdata => {
                                        uploadfile.uploadform(osdata).then(updata => {
                                            // this.uploadSuccess(updata, osdata.fileidlist)
                                            let {
                                                file,
                                                uuid
                                            } = updata
                                            let filecon = {}
                                            let filesize =file.size
                                            if(filesize>1024){
                                                filesize=filesize/1024
                                                filesize = filesize.toFixed(1) + 'kb'
                                            }else if(filesize/1024>1024){
                                                filesize = filesize/1024/1024
                                                filesize = filesize.toFixed(1) + 'mb'
                                            }else{
                                                filesize = filesize+'b'
                                            }
                                            if (file.type === 'image/jpeg' || file.type === 'image/png') {
                                                filecon = {
                                                    Thumb: osdata.fileidlist[uuid].host + osdata.fileidlist[uuid].filename,
                                                    LinkUrl:osdata.fileidlist[uuid].host + osdata.fileidlist[uuid].filename
                                                }
                                            }
                                            v.content = JSON.stringify(filecon)
                                            resolve()
                                        },err => {
                                            reject()
                                        })
                                    }, err => {
                                        reject()
                                    })
                                    // setTimeout(res=>{
                                    //     console.log('图片上传完成')
                                    //     resolve('图片上传')
                                    // },4000)
                                
                            })
                        }
                        queue.push(upfun())
                    }
                });
                this.showloading=true
                this.loadtxt='正在上传图片...'
                Promise.all(queue).then(result=>{
                        //TODO
                    this.showloading=false
                    console.log(result,'完成了图片上传，',arr)
                    // return false
                    arr.forEach(v=>{
                        let type = v.type == 'img' ? 2:1
                        this.socketApi.sendSock({
                            msgType: "TALK_TO_FRIEND_REQ",
                            msgContent: {
                                weChatId: this.selectfriendids.wechatContactinfo.wechatid,
                                friendId: this.selectfriendids.wechatContactinfo.friendid,
                                contentType: type,
                                content: v.content.replace(/&nbsp;/g, ''),
                                sendUuid: v.uuid,
                                sendStatus:1
                            }
                        })
                    })
                    this.chatValue = '' //发送内容后清空输入内容
                    console.log('清除输入框',this.$refs.texareaModel)
                    this.$refs.texareaModel.clearval()//清空输入框
                }).catch(err=>{
                    console.log(err,'err')
                })
            },
            resetchatarr(arr){
                // 重组并取出文字和图片数组
                const reg = /(<img[^>]*>)/;
                const srcreg = /<img [^>]*src=['"]([^'"]+)[^>]*>/gi;
                const namereg = /<img [^>]*data-name=['"]([^'"]+)[^>]*>/gi;
                const typereg = /<img [^>]*data-type=['"]([^'"]+)[^>]*>/gi;
                // var reg = /(<img[^>]*>)/;
                // var srcreg = /(?<=(src="))[^"]*?(?=")/ig;
                // var namereg = /(?<=(data-name="))[^"]*?(?=")/ig;
                // var typereg = /(?<=(data-type="))[^"]*?(?=")/ig;
                let obj = {
                    imgarr:[],
                    txtarr:[],
                    newarr:[]
                }
                arr.forEach(v => {
                    let uuid = uploadfile.generateUUID()
                    let bool = reg.test(v)
                    if(bool){
                        // 图片
                        let base64file,base64name,base64type
                        v.replace(srcreg, function (match, capture) {
                            base64file = capture
                        })
                        v.replace(namereg, function (match, capture) {
                            base64name = capture
                        })
                        v.replace(typereg, function (match, capture) {
                            base64type = capture
                        })
                        console.log(base64file,base64name,base64type)
                        if(base64file.indexOf('http') != -1){
                            obj.imgarr.push('')
                            let imgobj = {
                                Thumb:base64file,
                                LinkUrl:base64file
                            }
                            obj.newarr.push({
                                content:JSON.stringify(imgobj),
                                uuid:uuid,
                                type:'img',
                                file:''
                            })
                        }else{
                            let imgfile = uploadfile.dataURItoFile(base64file,base64type,base64name)
                            console.log(imgfile,'imgfile')
                            obj.imgarr.push(imgfile)
                            obj.newarr.push({
                                content:v,
                                uuid:uuid,
                                type:'img',
                                file:imgfile
                            })
                        }
                    }else{
                        // 文字
                        obj.txtarr.push(v)
                        obj.newarr.push({
                            content:v,
                            uuid:uuid,
                            type:'txt'
                        })
                    }
                })
                console.log(obj)
                return obj
            },
            oppenFile() {
                this.showFile = !this.showFile
            },
            // 发送文件
            sendfile(e) {
                let file = e.target.files[0];
                if(!file){
                    return false
                }
                //校验
                this.showloading=true
                this.loadtxt='正在上传文件...'
                this.uploadCheck(file).then(data => {
                    //获取oss
                    uploadfile.getossbase(data.file,true).then(osdata => {
                        //上传
                        uploadfile.uploadform(osdata).then(updata => {
                            //成功回调
                            this.uploadSuccess(updata, osdata.fileidlist)
                            this.showloading=false
                        }).catch(err=>{
                            this.showloading=false
                        })
                    }).catch(err=>{
                        this.showloading=false
                    })
                }).catch(err=>{
                    this.showloading=false
                })
            },
            stringToArray(str) {
                let reg = /(<img[^>]*>)/ig,
                    arr = [];
                arr = str.split(reg)
                // 去掉数组中空元素
                for(var i in arr){
                    if( !arr[i] ) {
                        arr.splice(i,1)
                    }
                }
                return arr;
            },

            // 上传回调
            uploadSuccess(data, fileidlist) {
                let {
                    file,
                    uuid
                } = data
                let contenttype = null
                let filecon = {}
                let filesize =file.size
                if(filesize>1024){
                    filesize=filesize/1024
                    filesize = filesize.toFixed(1) + 'kb'
                }else if(filesize/1024>1024){
                    filesize = filesize/1024/1024
                    filesize = filesize.toFixed(1) + 'mb'
                }else{
                    filesize = filesize+'b'
                }
                // {"linkUrl":"","coverUrl":"","source":"微信电脑版","title":"www.docx","type":"6","typeStr":"[文件]","fileSize":"10.7KB","fileSuffix":"docx","des":"10.7KB, docx"}
                if (file.type === 'image/jpeg' || file.type === 'image/png') {
                    contenttype = 2
                    filecon = {
                        Thumb: fileidlist[uuid].host + fileidlist[uuid].filename
                    }
                    filecon.LinkUrl = fileidlist[uuid].host + fileidlist[uuid].filename
                }else if (file.type === 'audio/mp3') {
                    contenttype = 8
                    filecon = {
                        Title: file.name,
                        Type:6,
                        TypeStr:"[文件]",
                        Des:filesize+', mp3',
                        Thumb: fileidlist[uuid].host + fileidlist[uuid].filename
                    }
                    filecon.Url = fileidlist[uuid].host + fileidlist[uuid].filename
                }else if (file.type === 'video/mp4') {
                    contenttype = 4
                    filecon = {
                        Thumb: fileidlist[uuid].host + fileidlist[uuid].filename +
                            "?x-oss-process=video/snapshot,t_0,m_fast",
                    }
                    filecon.LinkUrl = fileidlist[uuid].host + fileidlist[uuid].filename
                }else{
                    contenttype = 8
                    let fileSuffix = fileidlist[uuid].type.replace('.','')
                    filecon = {
                        Title: file.name,
                        Type:6,
                        TypeStr:"[文件]",
                        Des:filesize+', '+fileSuffix,
                        Thumb: fileidlist[uuid].host + fileidlist[uuid].filename,
                    }
                    filecon.Url = fileidlist[uuid].host + fileidlist[uuid].filename
                }

                let suuid = uploadfile.generateUUID()
                filecon = JSON.stringify(filecon)
                this.MSGID(suuid) //保存uuid

                this.socketApi.sendSock({
                    msgType: "TALK_TO_FRIEND_REQ",
                    msgContent: {
                        weChatId: this.selectfriendids.wechatContactinfo.wechatid,
                        friendId: this.selectfriendids.wechatContactinfo.friendid,
                        contentType: contenttype,
                        content: filecon,
                        sendUuid: suuid
                    }
                })
            },
            // 上传失败回调
            uploadError(res) {
                console.log(res, '上传失败')
                this.showloading=false
            },
            uploadCheck(file) {
                console.log(file,'file')
                let pos = file.name.lastIndexOf(".");
                let suffix = '';
                let type = ''
                if (pos != -1) {
                    suffix = file.name.substring(pos);
                    console.log(suffix, 'suffix')
                    suffix = suffix.toLocaleLowerCase()
                }

                const isfile = suffix === '.jpg' || suffix === '.png' || suffix === '.mp4' || suffix === '.mp3' || suffix === '.doc' || suffix === '.docx' || suffix  === '.ppt' || suffix === '.pptx' || suffix === '.xls' || suffix === '.xlsx' || suffix === '.pdf';
                const isLt25M = file.size / 1024 / 1024 < 25;
                const isLt100M = file.size / 1024 / 1024 < 100;
                console.log(file, isfile, isLt25M, isLt100M)
                //格式校验
                return new Promise((resolve, reject) => {
                    if (!isfile) {
                        this.$toast('只能上传JPG/PNG/MP4/MP3/word/Excel/ppt/pdf 格式!');
                        reject(false)
                    }
                    //大小校验
                    if (file.type === 'video/mp4') {
                        type = "4"
                        
                        if (!isLt25M) {
                            this.$toast('选择视频大小不能超过 25MB!');
                            reject(false)
                        }
                    }else if (file.type === 'audio/mpeg') {
                        type = "3"
                        if (!isLt100M) {
                            this.$toast('选择音频文件大小不能超过 100MB!');
                            reject(false)
                        }
                    } else if (file.type === 'image/jpeg' || file.type === 'image/png') {
                        type = "2"
                        if (!isLt25M) {
                            this.$toast('选择图片大小不能超过 25MB!');
                            reject(false)
                        }
                    } else {
                        type = "5"
                        if (!isLt100M) {
                            this.$toast('选择文件大小不能超过 100MB!');
                            reject(false)
                        }
                    }
                    resolve({
                        file: file,
                        type:type,
                        suffix:suffix
                    })
                })
            },

            // 关闭录音
            closeRecorder() {
                this.showRecorder = false
            },
            closeexpression(){
                this.showexpression = false
            },
            oppenchart(){
               this.chartVisible=true
               this.showexpression = false
            },
            // 打开录音弹窗
            oppenRecorder() {
                this.showRecorder = true
                this.showexpression = false
            },
            // 设置聊天输入框
            resetchatheight() {
                let wh = document.body.clientHeight
                let chatHeight = localStorage.getItem('chatHeight')
                
                let chatconheight = 0
                if (chatHeight) {
                    this.getlistheight = chatHeight
                    chatconheight = wh - 110 - this.getlistheight
                } else {
                    this.getlistheight = ''
                    chatconheight = wh - 290
                }
                console.log(wh, chatconheight, this.getlistheight)
                this.$emit('changefun',{
                    type:'changeheight',
                    data: chatconheight
                })
            },
            // 拖拽输入框改变高度
            mouseDownTop(e) {
                let obj = document.getElementById('dropline')
                let fobj = document.getElementById('textArea')
                let chatobj = document.getElementById('chatCon')
                e = e || event;
                let firstY = e.clientY;
                let top = obj.offsetTop;
                let hh = fobj.offsetHeight
                let ch = chatobj.offsetHeight
                document.onmousemove = (e) => {
                    e = e || event;
                    let nehh = hh + (firstY - e.clientY);
                    if (nehh <= 140 || nehh >= 300) {
                        return false
                    }
                    this.getlistheight = nehh;
                    const chatconheight = ch - (firstY - e.clientY)
                    this.$emit('changefun',{
                        type:'changeheight',
                        data: chatconheight
                    })
                    localStorage.setItem('chatHeight', nehh)

                }
                document.onmouseup = () => {
                    document.onmousemove = null;
                    obj.onmousemove = null;
                }
                return false;
            },
        }
    }
</script>

<style lang="less" scoped>
    /* 输入框*/
    .textArea {
        height: 180px;
        border-top: 1px solid #E1E6F0;
        background: #F8F9FA;
        position: relative;

        .dropline {
            position: absolute;
            top: -1px;
            left: 0;
            width: 100%;
            height: 3px;
            cursor: row-resize;
            z-index: 1;
        }

        .newloading{
            .mask{
                position: fixed;
                top: 0;
                left: 0;
                width: 100%;
                height: 100%;
                background: rgba(0,0,0,0.4);
                z-index: 999;
            }
            .con{
                position: fixed;
                top: 50%;
                left: 50%;
                transform: translate(-50%,-50%);
                width: 244px;
                height: 120px;
                z-index: 1000;
                background: #000;
                border-radius: 4px;
                text-align: center;
                p{
                    color: #fff;
                    margin: 28px 0 18px;
                    font-size: 16px;
                }
                img{
                    width: 30px;
                    height: 30px;
                    animation: loadrotate 1.5s linear infinite;
                    transform: rotate(180deg);
                }
                @keyframes loadrotate {
                    from{
                        transform: rotate(0deg);
                    }
                    to{
                        transform: rotate(-360deg);
                    }
                }
            }
        }
        /* 表情框 */
        .expression {
            position: relative;

            .icon_bq_on {
                background: url(/static/img/icon_bq_on.png) center no-repeat;
                background-size: 100% 100%;
            }

            .icon_bq {
                background: url(/static/img/icon_bq.png) center no-repeat;
                background-size: 100% 100%;
                &:hover{
                    .icon_bq_on
                }
            }

            .icon_microphone_on{
                background: url(/static/img/icon_yuyin_on.png) center no-repeat;
                background-size: 100% 100%;
            }

            .icon_microphone{
                background: url(/static/img/icon_yuyin.png) center no-repeat;
                background-size: 100% 100%;
                &:hover{
                    .icon_microphone_on
                }
            }

            .icon_folder_add_on{
                background: url(/static/img/icon_floder_on.png) center no-repeat;
                background-size: 100% 100%;
            }
            .icon_folder_add {
                position: relative;
                background: url(/static/img/icon_floder.png) center no-repeat;
                background-size: 100% 100%;

                &:hover{
                    .icon_folder_add_on
                }

                input {
                    position: absolute;
                    top: 0;
                    left: 0;
                    width: 100%;
                    height: 100%;
                    opacity: 0;
                    font-size: 0 !important;
                    cursor: pointer;
                }
            }

            .icon_syschat_on{
                background: url(/static/img/icon_syschat_on.png) center no-repeat;
                background-size: 100% 100%;
            }

            .icon_syschat{
                background: url(/static/img/icon_syschat.png) center no-repeat;
                background-size: 100% 100%;
                &:hover{
                    .icon_syschat_on
                }
            }

            &>a,
            .uploadbox {
                display: inline-block;
                width: 18px;
                height: 18px;
                margin: 10px 0 10px 20px;
                vertical-align: middle;
                color: #93999F;
                font-size: 18px;
                &.active,&:hover {
                    color: #0077AA;
                }
            }

            .uploadbox a {
                color: #93999F;
            }
            .expressionlist {
                position: absolute;
                bottom: 30px;
                background: #fff;
                padding: 10px;
                height: 180px;

                li {
                    width: 20px;
                    height: 20px;
                    margin: 8px;
                    float: left;

                    a {
                        width: 24px;
                        height: 20px;
                        background: url(/static/img/qqface.png) -4px -4px no-repeat;
                    }

                    img {
                        width: 24px;
                        height: 24px;
                    }

                    /* 表情*/
                    .intro-loop(105);

                    .intro-loop(@n, @i: 1) when (@i <=@n) {
                        .intro-@{i} {
                            background-position: -4px + -29px * mod(@i , 15) -4px + -29px *floor(@i / 15);
                        }

                        .intro-loop(@n, (@i + 1))
                    }

                    .intromoji-loop(284);

                    .intromoji-loop(@n, @i: 105) when (@i <=@n ) {
                        .intromoji-@{i} {
                            background: url(/static/img/emoji.png) no-repeat;
                            background-size: 434px auto;
                            background-position: 1px+ -29px * mod(@i , 15) 202px + -29px *floor(@i / 15);
                        }

                        .intromoji-loop(@n, (@i + 1))
                    }

                }
            }
        }

        .chatinput {
            outline: none;
            padding: 10px;
            width: calc(100% - 20px);
            height: calc(100% - 56px);
            background: transparent;
            border: none;
            resize: none;

        }

        /* 发送按钮 */
        .btn_send {
            width: 76px;
            height: 32px;
            background: rgba(0, 153, 255, 1);
            border-radius: 2px;
            display: block;
            position: absolute;
            bottom: 20px;
            right: 20px;
            text-align: center;
            line-height: 32px;
            color: #fff;
        }
    }
</style>



// WEBPACK FOOTER //
// src/views/customerservice/components/InputBox.vue